import { isPositionEvent } from '@tunasong/schemas'
import type { RendererPlugin } from '../renderer.js'

const Notch: RendererPlugin = ({ laneHeight, event, pixelsPerSecond }) => {
  if (!isPositionEvent(event)) {
    return null
  }
  const x = event.start * pixelsPerSecond
  const y = laneHeight * 2

  return <rect x={x} y={y} width={1} height={laneHeight} fill={'var(--tuna-palette-text-primary)'} />
}

export default Notch
